import { render, staticRenderFns } from "./CommercialInvoice.vue?vue&type=template&id=2bf36327"
import script from "./CommercialInvoice.vue?vue&type=script&lang=ts"
export * from "./CommercialInvoice.vue?vue&type=script&lang=ts"
import style0 from "./CommercialInvoice.vue?vue&type=style&index=0&id=2bf36327&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports